export enum RegistryTypeEnum {
  AZIENDA = "AZIENDA",
  SEDE = "SEDE",
  DIPENDENTE = "DIPENDENTE",
  AMMINISTRATORE = "AMMINISTRATORE",
}